const data = {
    type: 'contactpage',
    path: '/contact',
    meta: {
        title: 'Contact us | Child Poverty',
    },
    title: 'Contact us',
};

export default data;
